import React from 'react';
import {
  Grid,
  Typography,
  Stack,
} from '@mui/material';
import SubTask_Icon from '../../../assets/images/SubTask_Icon.svg';
import Edit_Icon from '../../../assets/images/CommonTableImg/Edit_Icon.svg';
import Delete_Icon2 from '../../../assets/images/CommonTableImg/Delete_Icon.svg';
import { getStatusLabel, minutesToHours } from '../utils/helpers';

const SubTasks = ({ subTasks, onSubTaskDelete, onSubTaskEdit, onSubTaskView }) => {
  if (!Array.isArray(subTasks) || subTasks.length === 0) {
    return null;
  }

  return (
    <>
      <Typography
        sx={{
          fontSize: '16px',
          color: '#181818',
          mt: 3,
          fontWeight: 700,
        }}
      >
        Sub Tasks
      </Typography>
      <Grid>
        {subTasks.map((task) => (
          <div key={task._id}>
            <Stack direction={'row'} alignItems={'center'}>
              <Grid
                item
                xs={12}
                sm={2.5}
                mt={1}
                sx={{
                  background: '#E4E4E7',
                  padding: '5px 10px',
                  display: 'flex',
                  justifyContent: 'left',
                  alignItems: 'center',
                  fontSize: '14px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  gap: 1,
                }}
                onClick={(e) => onSubTaskView(e, task._id)}
              >
                <img src={SubTask_Icon} alt="SubTask_Icon" />
                {task?.workType}
              </Grid>
              <Grid
                item
                xs={12}
                sm={9}
                mt={1}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '10px',
                  padding: '7px',
                  fontSize: '14px',
                  border: '1px solid #e4e4e7',
                }}
              >
                <Grid
                  sx={{ cursor: 'pointer' }}
                  onClick={(e) => onSubTaskView(e, task._id)}
                >
                  {getStatusLabel(task?.status)} -{' '}
                  {minutesToHours(task.timeSpend)}
                </Grid>
                <Grid
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '20px',
                  }}
                >
                  <img
                    src={Edit_Icon}
                    alt="Edit-icon"
                    style={{
                      display: 'inline',
                      cursor: 'pointer',
                      height: '20px',
                      width: '20px',
                    }}
                    onClick={(e) => onSubTaskEdit(e, task._id)}
                  />
                  <img
                    src={Delete_Icon2}
                    alt="Delete-icon"
                    style={{
                      display: 'inline',
                      cursor: 'pointer',
                      height: '18px',
                      width: '18px',
                    }}
                    onClick={() => onSubTaskDelete(task._id)}
                  />
                </Grid>
              </Grid>
            </Stack>
          </div>
        ))}
      </Grid>
    </>
  );
};

export default SubTasks;
